import styled from 'styled-components'

export const CustomRadiologyContainer = styled.div`
  margin-top: 2rem;
  font-size: 16px;
  line-height: 22px;
  color: var(--grey2);
  list-style-position: inside;
`
